import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'
import { encryption } from '../../utilities/encryption'

export type ChangeUserPasswordProps = {
    userId: number
    newPassword: string
}

const useInfoChangePassword = () => {
    const callApi = useCallApi()

    const changeUserPasswordById = async (param: ChangeUserPasswordProps) => {
        if (param.userId) {
            try {
                const { data } = await callApi.axiosPut<any>({
                    url: `${umServinceURL.putUserPassword}/${param.userId}`,
                    authorizationType: 'authorization',
                    params: {
                        newPassword: encryption(param.newPassword)
                    }
                })
                return data
            } catch (error) {
                console.log('error', error)
            }
        }
    }

    return {
        changeUserPasswordById
    }
}

export default useInfoChangePassword
